import { c as _c } from "react/compiler-runtime";
import type * as React from 'react';
import { cn } from '@/app/_lib/utils';
type TRPCLogoProps = React.SVGProps<SVGSVGElement> & {
  size?: number;
  color?: string;
};
export const TRPCLogo: React.FC<TRPCLogoProps> = t0 => {
  const $ = _c(24);
  let props;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== t0) {
    const {
      size: t10,
      width,
      height,
      ...t11
    } = t0;
    props = t11;
    const size = t10 === undefined ? 32 : t10;
    t1 = "http://www.w3.org/2000/svg";
    t2 = width ?? size;
    t3 = height ?? size;
    t4 = "0 0 32 32";
    t5 = "none";
    t6 = "true";
    t7 = "img";
    t8 = "tRPC logo";
    t9 = cn("fill-[#0369A1]", props.className);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    props = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <g clipPath="url(#clip0_7979_16584)"><path d="M32 16C32 24.8267 24.8267 32 16 32C7.17333 32 0 24.8267 0 16C0 7.17333 7.17333 0 16 0C24.8267 0 32 7.17333 32 16ZM1.61333 16C1.61158 17.8898 1.9825 19.7614 2.70488 21.5076C3.42726 23.2539 4.4869 24.8405 5.82318 26.1768C7.15945 27.5131 8.74612 28.5727 10.4924 29.2951C12.2386 30.0175 14.1102 30.3884 16 30.3867C17.8898 30.3884 19.7614 30.0175 21.5076 29.2951C23.2539 28.5727 24.8405 27.5131 26.1768 26.1768C27.5131 24.8405 28.5727 23.2539 29.2951 21.5076C30.0175 19.7614 30.3884 17.8898 30.3867 16C30.3884 14.1102 30.0175 12.2386 29.2951 10.4924C28.5727 8.74612 27.5131 7.15945 26.1768 5.82318C24.8405 4.4869 23.2539 3.42726 21.5076 2.70488C19.7614 1.9825 17.8898 1.61158 16 1.61333C14.1102 1.61158 12.2386 1.9825 10.4924 2.70488C8.74612 3.42726 7.15945 4.4869 5.82318 5.82318C4.4869 7.15945 3.42726 8.74612 2.70488 10.4924C1.9825 12.2386 1.61158 14.1102 1.61333 16ZM16.1667 7.88533L19.0493 9.54933C19.1001 9.57865 19.1422 9.62083 19.1715 9.67163C19.2008 9.72243 19.2161 9.78004 19.216 9.83867V11.3093L22.5133 13.2133C22.5641 13.2426 22.6062 13.2848 22.6355 13.3356C22.6648 13.3864 22.6801 13.444 22.68 13.5027V16.6427L23.9533 17.3773C24.0041 17.4066 24.0462 17.4488 24.0755 17.4996C24.1048 17.5504 24.1201 17.608 24.12 17.6667V20.9947C24.1201 21.0533 24.1048 21.1109 24.0755 21.1617C24.0462 21.2125 24.0041 21.2547 23.9533 21.284L21.0707 22.948C21.02 22.9773 20.9625 22.9927 20.904 22.9927C20.8455 22.9927 20.788 22.9773 20.7373 22.948L19.4627 22.212L16.1667 24.1147C16.116 24.1439 16.0585 24.1593 16 24.1593C15.9415 24.1593 15.884 24.1439 15.8333 24.1147L12.5373 22.212L11.2627 22.948C11.212 22.9773 11.1545 22.9927 11.096 22.9927C11.0375 22.9927 10.98 22.9773 10.9293 22.948L8.04667 21.284C7.9959 21.2547 7.95376 21.2125 7.92449 21.1617C7.89523 21.1109 7.87988 21.0533 7.88 20.9947V17.6667C7.87988 17.608 7.89523 17.5504 7.92449 17.4996C7.95376 17.4488 7.9959 17.4066 8.04667 17.3773L9.32 16.6427V13.5027C9.31988 13.444 9.33523 13.3864 9.36449 13.3356C9.39376 13.2848 9.4359 13.2426 9.48667 13.2133L12.784 11.3093V9.84C12.7839 9.78138 12.7992 9.72376 12.8285 9.67296C12.8578 9.62216 12.8999 9.57998 12.9507 9.55067L15.8333 7.88667C15.884 7.85741 15.9415 7.84201 16 7.84201C16.0585 7.84201 16.116 7.85608 16.1667 7.88533ZM17.8573 21.284C17.8066 21.2547 17.7644 21.2125 17.7352 21.1617C17.7059 21.1109 17.6906 21.0533 17.6907 20.9947V17.6667C17.6906 17.608 17.7059 17.5504 17.7352 17.4996C17.7644 17.4488 17.8066 17.4066 17.8573 17.3773L20.7373 15.7133C20.788 15.6841 20.8455 15.6687 20.904 15.6687C20.9625 15.6687 21.02 15.6841 21.0707 15.7133L22.0133 16.2573V13.6947L19.216 12.0813V13.1667C19.2161 13.2253 19.2008 13.2829 19.1715 13.3337C19.1422 13.3845 19.1001 13.4267 19.0493 13.456L16.1667 15.12C16.116 15.1493 16.0585 15.1647 16 15.1647C15.9415 15.1647 15.884 15.1493 15.8333 15.12L12.9507 13.456C12.8999 13.4267 12.8578 13.3845 12.8285 13.3337C12.7992 13.2829 12.7839 13.2253 12.784 13.1667V12.08L9.98667 13.6947V16.2573L10.9293 15.7133C10.98 15.6841 11.0375 15.6687 11.096 15.6687C11.1545 15.6687 11.212 15.6841 11.2627 15.7133L14.1427 17.3773C14.1934 17.4066 14.2356 17.4488 14.2648 17.4996C14.2941 17.5504 14.3095 17.608 14.3093 17.6667V20.9947C14.3095 21.0533 14.2941 21.1109 14.2648 21.1617C14.2356 21.2125 14.1934 21.2547 14.1427 21.284L13.2027 21.828L16 23.4427L18.7973 21.828L17.8573 21.284ZM13.4507 12.9733L15.6667 14.2533V11.688L13.4507 10.4147V12.9733ZM18.5493 12.9733V10.4147L16.3333 11.688V14.2533L18.5493 12.9733ZM16 8.55733L13.7867 9.83733L16 11.1093L18.2133 9.83733L16 8.55733ZM8.54667 20.8027L10.76 22.08V19.5187L8.54667 18.244V20.8027ZM13.6427 20.8027V18.2427L11.4267 19.5187V22.0827L13.6427 20.8027ZM11.096 16.388L8.88 17.668L11.0947 18.9413L13.308 17.6667L11.096 16.388ZM18.3573 20.8013L20.5707 22.0813V19.5187L18.3573 18.244V20.8013ZM23.4533 20.8013V18.244L21.2373 19.5187V22.0813L23.4533 20.8013ZM20.904 16.388L18.6907 17.668L20.904 18.9413L23.1173 17.6667L20.904 16.388Z" /></g>;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <defs><clipPath id="clip0_7979_16584"><rect width="32" height="32" fill="white" /></clipPath></defs>;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== props || $[14] !== t1 || $[15] !== t2 || $[16] !== t3 || $[17] !== t4 || $[18] !== t5 || $[19] !== t6 || $[20] !== t7 || $[21] !== t8 || $[22] !== t9) {
    t12 = <svg xmlns={t1} width={t2} height={t3} viewBox={t4} fill={t5} aria-hidden={t6} role={t7} aria-label={t8} className={t9} {...props}>{t10}{t11}</svg>;
    $[13] = props;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
};